let layers = {
  buttons: [
    {
      id: 'cyclones',
      title: 'Cyclones',
      segments: [
        {
          value: 'tropical-cyclones',
          title: 'Tropical Cyclones'
        },
        {
          value: 'tropical-cyclones-forecast-point-icons',
          title: 'Tropical Cyclones - Forecast Icons'
        },
        {
          value: 'tropical-cyclones-break-points',
          title: 'Tropical Cyclones - Breakpoints'
        },
        {
          value: 'tropical-cyclones-track-point-icons',
          title: 'Tropical Cyclones - Track Icons'
        }
      ],
      options: {
        style: {
          zIndex: 0
        }
      }
    },
    {
      id: 'severe',
      title: 'Severe',
      segments: [
        {
          value: 'alerts',
          title: 'Alerts'
        },
        {
          value: 'stormreports',
          title: 'Storm Reports'
        }
      ],
      options: {
        style: {
          zIndex: 0
        }
      }
    },
    {
      id: 'forecasts',
      title: 'Forecasts',
      segments: [
        {
          value: 'ftemperatures',
          title: 'Forecast Temperatures'
        },
        {
          value: 'fqpf-accum',
          title: 'Forecast Precip Accum'
        },
        {
          value: 'fqsf-accum',
          title: 'Forecast Snow Accum'
        },
        {
          value: 'fsnow-depth',
          title: 'Forecast Snow Depth'
        },
        {
          value: 'fwind-speeds',
          title: 'Forecast Winds'
        },
        {
          value: 'fwind-gusts',
          title: 'Forecast Wind Gusts'
        },
        {
          value: 'fvisibility',
          title: 'Forecast Visibility'
        }
      ],
      options: {
        style: {
          zIndex: 0
        }
      }
    },
    {
      id: 'observations',
      title: 'Observations',
      segments: [
        {
          value: 'temperatures',
          title: 'Temperatures'
        },
        {
          value: 'wind-speeds',
          title: 'Wind Speeds'
        },
        {
          value: 'wind-gusts',
          title: 'Wind Gust'
        },
        {
          value: 'wave-heights',
          title: 'Wave Heights'
        },
        {
          value: 'visibility',
          title: 'Visibility'
        },
        {
          value: 'precip',
          title: 'Precipitation'
        },
        {
          value: 'snow-depth',
          title: 'Estimated Snow Depth'
        }
      ],
      options: {
        style: {
          zIndex: 0
        }
      }
    },
    {
      id: 'satellite',
      title: 'Radar and Satellite',
      segments: [
        {
          value: 'fradar',
          title: 'Forecast Radar'
        },
        {
          value: 'fsatellite',
          title: 'Forecast Satellite'
        }
      ],
      options: {
        style: {
          zIndex: 0
        }
      }
    },
    {
      id: 'roads',
      title: 'Roads',
      segments: [
        {
          value: 'road-conditions',
          title: 'Road Conditions'
        },
        {
          value: 'road-conditions-index',
          title: 'Road Conditions Index'
        },
        {
          value: 'froad-conditions-index-midterm',
          title: 'Future Road Conditions Index (Midterm)'
        }
      ],
      options: {
        style: {
          zIndex: 0
        }
      }
    }
  ],
  toggleable: true
}

let timeline = {
  toggleable: true
}

export const AERISWEATHER_CONFIG = {
  layers,
  timeline
}
